// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InsertRowBelowOutlinedSvg from "@fishx/icons-svg/es/asn/InsertRowBelowOutlined";
import FishxIcon from '../components/FishxIcon';

var InsertRowBelowOutlined = function InsertRowBelowOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: InsertRowBelowOutlinedSvg
  }));
};

InsertRowBelowOutlined.displayName = 'InsertRowBelowOutlined';
export default React.forwardRef(InsertRowBelowOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/InsertRowBelowOutlined.js
// module id = 2980
// module chunks = 0